import React, { Component } from 'react'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import ReplayIcon from '@material-ui/icons/Replay'
import IconButton from '@material-ui/core/IconButton'

const styles = theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    inline: {
      display: 'inline',
    },
    item: {
        marginBottom: '24px', 
        borderBottom: '1px solid #f2f2f2',
    },
    message: {
        marginTop: '12px',
        marginBottom: '12px',
    },
    name: {
        fontWeight: "500",
        fontSize: '17px',
    },
    time : {
        marginTop: '6px',
        fontSize: '13px',
        fontWeight: '400',
        color: '#b3b3b3',
        display: 'inline'
    },
    bigAvatar: {
      width: 60,
      height: 60,
    },
    avatar: {
      color: '#fff',
      width: 60,
      height: 60,
      background: '#f2f2f2'
    },
    icons: {
        display: 'inline',
        marginLeft: '6px',
    },
    icon: {
        opacity: '.4',
        fontSize: '1.3em',
        '&:hover': {
            opacity: '1'
        }
        
    },
    button: {
        fontSize: '1.1em',
        padding: '6px',
        marginTop: '-3px'
      },
     unread: {
         background: 'rgba(196,255,203, .6)'
     }
  });
 class NotificationItem extends Component {
    constructor(props){
        super(props);
        this.state = {
            date: '',
            from: '',
            message: '',
            time: '',
            status: '',
            avatar: '',
            messageId: ''
        }
      }
      handleStatus = () => {
          this.setState({
              ...this.state,
              status: 'read'
          })
    
        }
    componentDidMount = () => {
        let data = this.props.data
        this.setState({
            date: data.date,
            from: data.from,
            message: data.message,
            time: data.time,
            status: data.status
        })
       // setTimeout(this.handleStatus(), 10000);
    }
    render() {
        const { classes } = this.props;
       // console.log('NotificationItem', this.props)
        //console.log('NotificationItem State', this.state)
        var unread = '#fff'
        if(this.state.status !== 'read'){
            unread = "fadeOutBackground"
        }
        return (
            <ListItem key={this.state.fromId} alignItems="flex-start" className={[classes.item, unread].join(' ')} style={{background: unread }}>
                <ListItemAvatar>
                { this.state.avatar ? 
                        <Avatar alt={this.state.from} src={this.state.avatar} className={classes.bigAvatar} />
                    :
                        <Avatar style={{background: this.props.color}} className={classes.avatar}>{((this.state.from || "").charAt(0) || "").toUpperCase()} </Avatar>

                }
                </ListItemAvatar>
                <ListItemText
                    primary=
                    {<Typography type="body2" className={classes.name}>{this.state.from}</Typography>}
                    secondary={
                        <React.Fragment>
                            <Typography component="span" className={classes.message} color="textPrimary">
                                { this.state.message}
                            </Typography>
                            
                            <Typography component="span" className={classes.time} color="textPrimary">
                            { this.state.time}  -  { this.state.date}
                            
                            </Typography> <div className={classes.icons}>
                                <IconButton className={classes.button} aria-label="Delete">
                                   <DeleteForeverIcon className={classes.icon}/>
                                   </IconButton>
                                <IconButton className={classes.button} aria-label="Replay">
                                   <ReplayIcon className={classes.icon}/>
                                </IconButton>
                            </div>
                        </React.Fragment>
                        
                }
                />
            </ListItem>
        )
    }
}

NotificationItem.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(NotificationItem)
